import {gql} from '@apollo/client'

export const CREATE_BOTMAKER_WHATSAPP_TEMPLATE = gql`
  mutation CreateBotmakerWhatsappTemplate($input: CreateBotmakerTemplateInput!) {
    createBotmakerWhatsappTemplate(input: $input) {
      success
      message
      template {
        id
        name
        locale
        category
        status
        createdAt
        updatedAt
      }
    }
  }
`

export const SEND_BOTMAKER_WHATSAPP_TEMPLATE = gql`
  mutation SendBotmakerWhatsappTemplate(
    $phone: String!
    $templateName: String!
    $language: String
    $params: [String]
    $variables: GenericScalar
    $channelId: String
    $module: String
    $objectId: String
  ) {
    sendBotmakerWhatsappTemplate(
      phone: $phone
      templateName: $templateName
      language: $language
      params: $params
      variables: $variables
      channelId: $channelId
      module: $module
      objectId: $objectId
    ) {
      success
      message
      providerId
    }
  }
`

export const SYNC_BOTMAKER_TEMPLATES = gql`
  mutation SyncBotmakerTemplates {
    syncBotmakerTemplates {
      success
      message
      count
    }
  }
`

export const UPDATE_BOTMAKER_TEMPLATE_CONFIG = gql`
  mutation UpdateBotmakerTemplateConfig($pTemplateId: ID!, $allowedModules: [String], $variableMapping: GenericScalar) {
    updateBotmakerTemplateConfig(pTemplateId: $pTemplateId, allowedModules: $allowedModules, variableMapping: $variableMapping) {
      success
      message
      template {
        id
        allowedModules
        variableMapping
      }
    }
  }
`

export const TOGGLE_BOTMAKER_TEMPLATE_ACTIVE = gql`
  mutation ToggleBotmakerTemplateActive($botmakerId: String!, $isActive: Boolean!) {
    toggleBotmakerTemplateActive(botmakerId: $botmakerId, isActive: $isActive) {
      success
      message
      template {
        id
        name
        isActive
      }
    }
  }
`

export const ARCHIVE_BOTMAKER_TEMPLATE = gql`
  mutation ArchiveBotmakerTemplate($botmakerId: String!) {
    archiveBotmakerTemplate(botmakerId: $botmakerId) {
      success
      message
      template {
        id
        name
        isActive
        isArchived
      }
    }
  }
`
export const DELETE_BOTMAKER_WHATSAPP_TEMPLATE = gql`
  mutation DeleteBotmakerWhatsappTemplate($botmakerId: String!) {
    deleteBotmakerWhatsappTemplate(botmakerId: $botmakerId) {
      success
      message
    }
  }
`
export const SEND_BOTMAKER_TEXT_MESSAGE = gql`
  mutation SendBotmakerTextMessage(
    $phone: String!
    $text: String!
    $module: String
    $objectId: String
  ) {
    sendBotmakerTextMessage(
      phone: $phone
      text: $text
      module: $module
      objectId: $objectId
    ) {
      success
      message
      providerId
    }
  }
`
